import { useApp, useValues } from '@k3/core'

type productType =
  | 'veranda-free'
  | 'veranda-basic'
  | 'veranda-pro'
  | 'veranda-enterprise'
  | 'free'
  | 'basic'
  | 'pro'
  | 'enterprise'

export const isForbiddenValues = (value: any) => {
  const app = useApp()
  const product = app.product
  if (!product) {
    return
  }

  return value.forbidden?.includes(product as productType) ? false : value.key
}

export const isMaxValuesPerVariable = (value: any, variable: any) => {
  const app = useApp()
  const currentValues = useValues().filter(
    (v) => v.variableId === variable?.variableId
  )
  const product = app.product
  if (!product) {
    return
  }

  const maxValue = value[product]
  if (maxValue < 0) return currentValues

  const sortedValues = currentValues.sort((a: any, b: any) => a.sort - b.sort)
  const filteredValues = sortedValues.find(
    (item: any) => item.id === variable?.id && item.sort < maxValue
  )

  return filteredValues ? true : false
}

export const getValuesColor = (value: any, variable: any) => {
  const app = useApp()
  const currentValues = useValues().filter(
    (v) => v.variableId === variable?.variableId
  )
  const product = app.product
  if (!product) {
    return
  }

  const maxValue = value[product]
  if (maxValue < 0) return currentValues

  const sortedValues = currentValues.sort((a: any, b: any) => a.sort - b.sort)

  return sortedValues[0].value
}
